module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm White Ceramic + White Open.6f575af0.png";